import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-two',
  templateUrl: './welcome-two.component.html',
  styleUrls: ['./welcome-two.component.css']
})
export class WelcomeTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
